<p [class]="containerClass">
  @if (questionText) {
    {{ questionText }}
  }
  @if (linkText && linkRoute) {
    <a [routerLink]="linkRoute" [class]="linkClass">{{ linkText }}</a>
  }
</p>
